import MainPages from './mainPages'

export default MainPages